/* DATORACODE - Sort Dropdown (CFSN-482): custom accessible dropdown that replaces the native <select> for sorting on collection pages. Keeps a visually-hidden <select name="sort_by"> for form submission so facets.js continues to pick up the change. */

(function () {
  if (customElements.get('sort-dropdown')) return;

  class SortDropdown extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.sort-dropdown__trigger');
      this.list = this.querySelector('.sort-dropdown__list');
      this.select = this.querySelector('.sort-dropdown__select');
      this.current = this.querySelector('.sort-dropdown__current');
      this.options = Array.from(this.querySelectorAll('.sort-dropdown__option'));

      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onOptionClick = this.onOptionClick.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
    }

    connectedCallback() {
      this.trigger.addEventListener('click', this.onTriggerClick);
      this.options.forEach((opt) => opt.addEventListener('click', this.onOptionClick));
      this.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    onTriggerClick(event) {
      /* DATORACODE - stopPropagation so MenuDrawer doesn't treat this as a click outside the drawer */
      event.stopPropagation();
      this.toggle();
    }

    open() {
      this.list.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
      document.addEventListener('click', this.onDocumentClick);
      const selected = this.options.find((o) => o.getAttribute('aria-selected') === 'true') || this.options[0];
      if (selected) selected.focus();
    }

    close() {
      this.list.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');
      document.removeEventListener('click', this.onDocumentClick);
    }

    toggle() {
      if (this.list.hidden) this.open();
      else this.close();
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    onOptionClick(event) {
      const value = event.currentTarget.dataset.value;
      this.selectValue(value);
      this.close();
      this.trigger.focus();
    }

    selectValue(value) {
      if (this.select.value === value) return;
      this.select.value = value;
      this.options.forEach((opt) => {
        const isSelected = opt.dataset.value === value;
        opt.classList.toggle('is-selected', isSelected);
        opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        if (isSelected && this.current) this.current.textContent = opt.textContent.trim();
      });
      /* DATORACODE - dispatch input + change so FacetFiltersForm picks up the new sort value and re-renders the grid */
      this.select.dispatchEvent(new Event('input', { bubbles: true }));
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onKeyDown(event) {
      const isOpen = !this.list.hidden;
      const key = event.key;

      if (event.target === this.trigger) {
        if (key === 'ArrowDown' || key === 'Enter' || key === ' ') {
          event.preventDefault();
          this.open();
        }
        return;
      }

      if (!isOpen) return;
      const currentIndex = this.options.indexOf(document.activeElement);

      if (key === 'ArrowDown') {
        event.preventDefault();
        const next = this.options[Math.min(currentIndex + 1, this.options.length - 1)];
        if (next) next.focus();
      } else if (key === 'ArrowUp') {
        event.preventDefault();
        const prev = this.options[Math.max(currentIndex - 1, 0)];
        if (prev) prev.focus();
      } else if (key === 'Home') {
        event.preventDefault();
        this.options[0]?.focus();
      } else if (key === 'End') {
        event.preventDefault();
        this.options[this.options.length - 1]?.focus();
      } else if (key === 'Enter' || key === ' ') {
        if (currentIndex >= 0) {
          event.preventDefault();
          this.selectValue(this.options[currentIndex].dataset.value);
          this.close();
          this.trigger.focus();
        }
      } else if (key === 'Escape') {
        event.preventDefault();
        this.close();
        this.trigger.focus();
      } else if (key === 'Tab') {
        this.close();
      }
    }
  }

  customElements.define('sort-dropdown', SortDropdown);
})();
